// src/auth/Protected.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

function useAuth() {
  const raw = localStorage.getItem("auth_user");
  const user = raw ? JSON.parse(raw) : null;
  return { user, isLoading: false };
}

export default function Protected({ any, children }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return null;
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (any?.length && !any.some((r) => user.roles?.includes(r))) {
    return <Navigate to="/403" replace />;
  }
  return children ?? <Outlet />;
}
